export default __webpack_public_path__ + "static/media/perfectMatchLogo.694e14c9.png";